<template>
  <div id='tags-view-container' class='tags-view-container'>
    <scroll-pane ref='scrollPane' class='tags-view-wrapper' @scroll='handleScroll'>
      <router-link
        v-for='tag in visitedViews'
        :key='tag.path'
        ref='tag'
        :class="isActive(tag, tag.path) ? 'active' : ''"
        :to='{ path: tag.path, query: tag.query, name: tag.name }'
        tag='span'
        class='tags-view-item'
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native='openMenu(tag, $event)'
      >
        <section class='content_tag' :class="{'driver-item-home': tag.fullPath === '/home'}">
          <span class='content_span'>{{ generateTitle(tag) }}</span>
          <span :class="tag.fullPath === '/home' ? 'iconfont icon-xiugaimima' : 'el-icon-circle-close'"
                @click.prevent.stop='closeSelectedTag(tag)' />
        </section>
      </router-link>
    </scroll-pane>
    <ul v-show='visible' :style="{ left: left + 'px', top: top + 'px' }" class='contextmenu'>
      <li @click='refreshSelectedTag(selectedTag)'>
        {{ $t('buttonTitle.Refresh') }}
      </li>
      <li v-if='!isAffix(selectedTag)' @click='closeSelectedTag(selectedTag)'>
        {{ $t('buttonTitle.SwitchOff') }}
      </li>
      <li @click='closeLeftTags'>{{ $t('buttonTitle.Close_left') }}</li>
      <li @click='closeRightTags'>{{ $t('buttonTitle.Close_right') }}</li>
      <li @click='closeOthersTags'>{{ $t('buttonTitle.Close_other') }}</li>
      <li @click='closeAllTags(selectedTag)' v-if='!isAffix(selectedTag)'>
        {{ $t('buttonTitle.Close_all') }}
      </li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import { generateTitle } from '@/utils/i18n'
import path from 'path'

export default {
  components: { ScrollPane },
  props: ['tagNum'],
  data () {
    return {
      visible: false,
      itemlist: [],
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews: {
      get () {
        return this.$store.state.tagsView.visitedViews
      },
      set (val) {
        return val
      }
    },
    routes () {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route () {
      console.log(this.$route)
      this.addTags()
      this.moveToCurrentTag()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
    this.initTags()
    this.addTags()
  },
  methods: {
    generateTitle, // generateTitle by vue-i18n
    isActive (route, path) {
      // if (route.path === this.$route.path) {
      //   this.$emit('choozeMenu', route)
      // }
      if (this.$route.path.indexOf('edituserLimits') != -1) {
        return route.path.indexOf('edituserLimits') != -1
      }
      return route.path === this.$route.path
    },
    isAffix (tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags (routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags () {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags () {
      const { name } = this.$route
      if (name && name != 'editUser') {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag () {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },

    // 刷新
    refreshSelectedTag (view) {
      /** 处理遗留问题  右键刷新 */
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },

    // 关闭当前
    closeSelectedTag (view) {
      if (view.fullPath === '/home') {
        return
      }
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },

    // 关闭其它
    closeOthersTags () {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },

    // 关闭左侧
    closeLeftTags () {
      this.$store.dispatch('tagsView/delLeftViews', this.selectedTag).then(({ visitedViews }) => {
        if (!visitedViews.some(v => v.path === this.$route.path)) {
          this.$router.push(this.selectedTag)
        } else {
          this.moveToCurrentTag()
        }
      })
    },

    // 关闭右侧
    closeRightTags () {
      this.$store.dispatch('tagsView/delRightViews', this.selectedTag).then(({ visitedViews }) => {
        if (!visitedViews.some(v => v.path === this.$route.path)) {
          this.$router.push(this.selectedTag)
        } else {
          this.moveToCurrentTag()
        }
      })
    },

    // 关闭所有
    closeAllTags (view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          // ？？？
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView (visitedViews, view) {
      // visitedViews===剩余数组  view====被删除元素
      // 跳回被删除的上一个  如果没有则跳回首页
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.path)
      } else {
        this.$router.push('/home')
      }
      // } else {
      //   if (view.path === 'home') {
      //     this.$router.push('/home')
      //   } else {
      //     this.$router.push('/home')
      //   }
      // }
    },
    //  右键功能
    openMenu (tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right
      if (left > maxLeft) {
        this.left = maxLeft + 210
      } else {
        this.left = left + 210
      }

      this.top = e.clientY + 10
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu () {
      this.visible = false
    },
    handleScroll () {
      this.closeMenu()
    },
    // 用户点击了其他标签 菜单需要做联动切换  去除该组件的路由跳转权限 全权交给菜单
    tagChange (tag) {
      // bus.$emit('layoutTabChange', tag);
    }
  }
}
</script>

<style lang='scss' scoped>
.tags-view-container {
  height: 100%;
  width: 100%;
  flex: 1;
  padding: 0px 10px 0px 20px;
  box-sizing: border-box;
  transition: all 1s;
  overflow: hidden;

  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      cursor: pointer;
      width: auto;
      height: 40px;
      font-size: 14px;
      z-index: 99;
      color: #ffffff;
      background: var(--primary-color);

      &.active {
        color: var(--primary-color);
        background-color: #ffffff;
      }

      .content_tag {
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        padding-right: 10px;
        box-sizing: border-box;

        .icon-xiugaimima,
        .el-icon-circle-close {
          font-size: 14px;
          color: #000000;
          font-weight: bold;
          display: inline-block;
          padding-top: 2px;
          //width: 16px;
          //height: 16px;
          text-align: left;
          box-sizing: border-box;
        }

        .content_span {
          flex: 1;
          text-align: center;
          box-sizing: border-box;
          padding: 0 15px;
        }

        .el-icon-circle-close:hover {
          //background-color: crimson;
          //border-radius: 50%;
          color: #ce0000;
        }
      }
    }

    .tags-view-item:last-child {
      margin-right: 0;
    }

    ::v-deep .el-scrollbar__view {
      padding: 0 !important;
      height: 100%;
      // display: flex;
    }
  }

  .contextmenu {
    margin: 0;
    background: $bg2;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: $txt4;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: $bg5;
      }
    }
  }
}
</style>
